import Moment from 'moment';
import Resource from './Resource';

/**
 * Note Resource
 */
class Note extends Resource
{
    constructor() {
        super('note', ['notes']);
    }
}   

export let NoteResource = new Note();

export let NoteSchema = function(defaults = {}) {
    let schema = {
        content: null,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}